const POPUPS = {
  APPROVAL_REQUIRED: 'APPROVAL_REQUIRED',
  AUTO_APPROVAL: 'AUTO_APPROVAL',
  CLOSE: 'CLOSE',
  CREATEAGREEMENT: 'CREATEAGREEMENT'
};

export { POPUPS };
